import UpdateCommentTTRequestModelBase from '../_generated/modelBases/update-comment-tt-request-model-base';

export default class UpdateCommentTTRequestModel extends UpdateCommentTTRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
